export const isNonViewableAreaClicked = ({ event, containerRef, imageRef }) => {
  event?.stopPropagation();
  const container = containerRef.current;
  const image = imageRef.current;

  if (!container || !image) return;

  const containerRect = container.getBoundingClientRect();
  const imageNaturalWidth = image.naturalWidth;
  const imageNaturalHeight = image.naturalHeight;

  const containerWidth = containerRect.width;
  const containerHeight = containerRect.height;

  // Calculate the actual rendered dimensions of the image
  const imageAspectRatio = imageNaturalWidth / imageNaturalHeight;
  const containerAspectRatio = containerWidth / containerHeight;

  let renderedWidth, renderedHeight;

  if (imageAspectRatio > containerAspectRatio) {
    renderedWidth = containerWidth;
    renderedHeight = containerWidth / imageAspectRatio;
  } else {
    renderedHeight = containerHeight;
    renderedWidth = containerHeight * imageAspectRatio;
  }
  // Calculate offsets (non-viewable areas)
  const offsetX = (containerWidth - renderedWidth) / 2;
  const offsetY = (containerHeight - renderedHeight) / 2;

  // Get click position relative to container
  const clickX = event.clientX - containerRect.left;
  const clickY = event.clientY - containerRect.top;

  // Check if click is in non-viewable area
  const isNonViewableClicked =
    clickX < offsetX ||
    clickX > offsetX + renderedWidth ||
    clickY < offsetY ||
    clickY > offsetY + renderedHeight;

  return isNonViewableClicked;
};
